var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chip',{staticClass:"issue-reason",class:{ 'selected-chip': _vm.isSelected },attrs:{"chipContent":_vm.label},nativeOn:{"click":function($event){return _vm.handleChipClick.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }